export default function () {
    const isEnabled = $("meta[name=googleRecaptchaEnabled]").attr("content") === "true";
    if (!isEnabled) {
        return;
    }
    const $form = $(".form-with-recaptcha");
    $form.on("focusin", reCaptchaOnFocus);

    function reCaptchaOnFocus() {
        const siteKey = $("meta[name=googleRecaptchaSiteKey]").attr("content");
        const head = document.getElementsByTagName("head")[0];
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
        head.appendChild(script);

        $form.off("focusin", reCaptchaOnFocus);
    }
}
